const getImageFiles = (files: ArrayLike<File> | null) => Array.from(files || []).filter((file) => (
  file.type.startsWith("image/") || /\.(jpe?g|png)$/i.test(file.name)
))

export const getClipboardImageFiles = (clipboardData: DataTransfer | null) => {
  const files = getImageFiles(clipboardData?.files || null)
  if (files.length || !clipboardData?.items) return files

  return getImageFiles(Array.from(clipboardData.items)
    .filter((item) => item.kind === "file")
    .map((item) => item.getAsFile())
    .filter((file): file is File => Boolean(file)))
}

const getClipboardData = (clipboardData: DataTransfer, type: string) => {
  try {
    return clipboardData.getData(type)
  } catch {
    return ""
  }
}

/**
 * Rich clipboard payloads may contain image files in addition to their HTML.
 * Those files must not make the image uploader consume the whole paste event,
 * otherwise ProseMirror never gets a chance to parse the formatted text.
 */
export const hasClipboardTextContent = (clipboardData: DataTransfer | null) => {
  if (!clipboardData) return false

  const plainText = getClipboardData(clipboardData, "text/plain")
  if (plainText.replace(/\u00a0/g, " ").trim()) return true

  const html = getClipboardData(clipboardData, "text/html")
  if (!html.trim()) return false

  const document = new DOMParser().parseFromString(html, "text/html")
  return Boolean(document.body.textContent?.replace(/\u00a0/g, " ").trim())
}

export const getClipboardImageFilesForUpload = (clipboardData: DataTransfer | null) => (
  hasClipboardTextContent(clipboardData) ? [] : getClipboardImageFiles(clipboardData)
)

export { getImageFiles }
